import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";
import styles from "./ActivityReport.module.css";

const ActivityTab = () => {
  const { id: userId } = useParams();
  const [activityData, setActivityData] = useState({
    today: { win: 0, pnl: 0 },
    days3: { win: 0, pnl: 0 },
    days7: { win: 0, pnl: 0 },
    days30: { win: 0, pnl: 0 },
    lifetime: { win: 0, pnl: 0 },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivityData = async () => {
      if (!userId) return;
      
      try {
        setLoading(true);
        const response = await api.get(`/admin/user/activity/${userId}`);
        if (response.data && response.data.success) {
          setActivityData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching activity data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivityData();
  }, [userId]);

  const formatNumber = (num) => {
    return Number(num).toFixed(2);
  };

  const getClass = (num) => {
    return Number(num) >= 0 ? styles.positive : styles.negative;
  };

  return (
    <div className={`bg-[#171b36] p-2 text-white ${styles.activityReport}`}>
      <div className={styles.mainPanel}>
        <div className={styles.leftPanel}>
          <table className={`${styles.table} ${styles.mT30}`}>
            <tbody>
              <tr>
                <td className={styles.textRight}>Win</td>
              </tr>
              <tr></tr>
              <tr>
                <td className={styles.textRight}>P&L</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.midPanel}>
          <table className={`${styles.table} ${styles.tableStriped}`}>
            <thead>
              <tr>
                <th className={styles.textCenter}>Today</th>
                <th className={styles.textCenter}>3 Days</th>
                <th className={styles.textCenter}>7 Days</th>
                <th className={styles.textCenter}>30 Days</th>
                <th className={styles.textCenter}>Lifetime</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.tableRow}>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.today.win)}>
                    {formatNumber(activityData.today.win)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days3.win)}>
                    {formatNumber(activityData.days3.win)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days7.win)}>
                    {formatNumber(activityData.days7.win)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days30.win)}>
                    {formatNumber(activityData.days30.win)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.lifetime.win)}>
                    {formatNumber(activityData.lifetime.win)}
                  </span>
                </td>
              </tr>
              <tr>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.today.pnl)}>
                    {formatNumber(activityData.today.pnl)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days3.pnl)}>
                    {formatNumber(activityData.days3.pnl)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days7.pnl)}>
                    {formatNumber(activityData.days7.pnl)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.days30.pnl)}>
                    {formatNumber(activityData.days30.pnl)}
                  </span>
                </td>
                <td className={styles.textCenter}>
                  <span className={getClass(activityData.lifetime.pnl)}>
                    {formatNumber(activityData.lifetime.pnl)}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ActivityTab;

